import { useEffect, useState } from "react";
import { getGlpiClient } from "../services/glpiClient";
import { GlpiEntity } from "../types/glpi";

export interface UseEntitiesResult {
  entities: GlpiEntity[];
  loading: boolean;
  error: string | null;
}

/** Charge la liste des entités GLPI accessibles avec le token courant. */
export function useEntities(enabled: boolean): UseEntitiesResult {
  const [entities, setEntities] = useState<GlpiEntity[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) return;
    const client = getGlpiClient();
    if (!client) return;

    let cancelled = false;
    setLoading(true);
    setError(null);
    client
      .listEntities()
      .then((data) => {
        if (!cancelled) setEntities(data);
      })
      .catch((e: Error) => {
        if (!cancelled) setError(e.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { entities, loading, error };
}
